<template>
  <input
    v-model="modelValue"
    data-slot="input"
    :data-size="size"
    :class="
      cn(
        'tw:file:text-foreground tw:placeholder:text-placeholder tw:placeholder:font-medium tw:selection:bg-primary tw:selection:text-primary-foreground tw:border-input-border tw:box-border tw:appearance-none tw:min-h-[var(--control-height)] tw:w-full tw:max-w-full tw:min-w-0 tw:rounded-control tw:border-[1.5px] tw:bg-input-surface tw:px-[16px] tw:py-[4px] tw:type-input tw:transition-[color,box-shadow] tw:outline-none tw:focus:bg-card tw:file:inline-flex tw:file:h-7 tw:file:border-0 tw:file:bg-transparent tw:file:type-body tw:file:font-medium tw:disabled:pointer-events-none tw:disabled:cursor-not-allowed tw:disabled:opacity-50',
        'tw:focus-visible:border-focus-border tw:focus-visible:ring-3 tw:focus-visible:ring-ring/25',
        'tw:data-[valid=true]:border-(--success) tw:data-[valid=true]:bg-(--success-soft)',
        'tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive',
        {
          'tw:min-h-[38px] tw:px-[6px]': size === 'compact',
          'tw:min-h-[54px] tw:type-measurement tw:border-[var(--border-measurement)] tw:bg-[var(--surface-dialog)] tw:placeholder:text-[var(--placeholder-measurement)] tw:placeholder:font-semibold tw:[appearance:textfield] tw:[&::-webkit-inner-spin-button]:appearance-none tw:[&::-webkit-outer-spin-button]:appearance-none':
            size === 'measurement',
          'tw:min-h-[50px] tw:bg-card tw:rounded-[1.0625rem] tw:shadow-[var(--shadow-soft)]':
            variant === 'search',
        },
        props.class,
      )
    "
  />
</template>

<script setup>
defineOptions({ name: 'UiInput' });
import { useVModel } from '@vueuse/core';
import { cn } from '@/shared/utilities/classes';

const props = defineProps({
  defaultValue: { default: undefined, type: [String, Number], required: false },
  modelValue: { default: undefined, type: [String, Number], required: false },
  size: { type: String, default: 'default' },
  variant: { type: String, default: 'default' },
  class: {
    default: undefined,
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const emits = defineEmits(['update:modelValue']);

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});
</script>
